import React from "react";

import "./DailyStreakCard.css";

import { Flame } from "lucide-react";

const DailyStreakCard = ({ data }) => {

    const streak = data?.dailyStreak || 0;

    const progress = Math.min((streak / 30) * 100, 100);

    return (

        <div className="daily-streak-card">

            <div className="daily-streak-header">

                <div>

                    <h3>

                        Daily Streak

                    </h3>

                    <p>

                        Keep your momentum alive.

                    </p>

                </div>

                <div className="streak-icon">

                    <Flame size={28} />

                </div>

            </div>

            <div className="streak-number">

                {streak}

            </div>

            <span className="streak-days">

                Day{streak !== 1 ? "s" : ""}

            </span>

            <div className="streak-progress">

                <div

                    className="streak-progress-fill"

                    style={{

                        width: `${progress}%`

                    }}

                ></div>

            </div>

            <div className="streak-footer">

                <span>

                    Target

                </span>

                <strong>

                    30 Days

                </strong>

            </div>

            <div className="streak-message">

                🔥 Complete one assessment today to continue your streak.

            </div>

        </div>

    );

};

export default DailyStreakCard;